import Cookies from "js-cookie";
import { createActionType, createAsyncAction } from "./create-actions";

export const ADD_DEPARTMENT = createActionType("ADD_DEPARTMENT");
export const GET_DEPARTMENTS = createActionType("GET_DEPARTMENTS");
export const GET_DEPARTMENT_BY_ID = createActionType("GET_DEPARTMENT_BY_ID");
export const EDIT_DEPARTMENT = createActionType("EDIT_DEPARTMENT");
export const REMOVE_DEPARTMENT = createActionType("REMOVE_DEPARTMENT");

export const addDepartment = (data: any) =>
  createAsyncAction(
    ADD_DEPARTMENT,
    "/department/add_department",
    "post",
    data,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const getDepartments = () =>
  createAsyncAction(
    GET_DEPARTMENTS,
    "/department/get_departments",
    "get",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const getDepartmentById = (id: any) => {
  createAsyncAction(
    GET_DEPARTMENT_BY_ID,
    `/department/get_department_by_id/${id}`,
    "get",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );
};

export const editDepartment = (id: any, data: any) =>
  createAsyncAction(
    EDIT_DEPARTMENT,
    `/department/edit_department/${id}`,
    "put",
    data,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const removeDepartment = (id: any) =>
  createAsyncAction(
    REMOVE_DEPARTMENT,
    `/department/remove_department/${id}`,
    "delete",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );
